import React from "react";
import Select from "react-select";
import NumberFormat from "react-number-format";
import "./pos-modal.css";

export const SALE_TYPES = [
  { value: "presencial", label: "Venda presencial" },
  { value: "online", label: "Venda online" },
];

export const TRANSPORT_TYPES = [
  { value: "motoboy", label: "Motoboy" },
  { value: "correios", label: "Serviços dos Correios" },
  { value: "jadlog", label: "Transportadora Jadlog" },
  { value: "presencial", label: "Presencial" },
];

export const SERVICE_TYPES = [
  { value: "1", label: "Entrega PAC à vista" },
  { value: "2", label: "Entrega SEDEX à vista" },
  { value: "3", label: "Entrega .Package à vista" },
  { value: "4", label: "Entrega .Com à vista" },
  { value: "0", label: "Motoboy" },
  { value: "P", label: "Presencial" },
];

// react-select vem com aparência própria (cantos e fonte diferentes do
// resto da página) — estiliza pra bater com .pos-modal-input.
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "auto",
    padding: "1px 4px",
    borderRadius: 6,
    borderColor: state.isFocused ? "#111" : "#ddd",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(0, 0, 0, 0.12)" : "none",
    fontSize: 13,
    fontFamily: "inherit",
    "&:hover": { borderColor: state.isFocused ? "#111" : "#ddd" },
  }),
  singleValue: (base) => ({ ...base, color: "#111", fontFamily: "inherit" }),
  input: (base) => ({ ...base, fontFamily: "inherit" }),
  placeholder: (base) => ({ ...base, fontFamily: "inherit", color: "#999" }),
  option: (base, state) => ({
    ...base,
    fontFamily: "inherit",
    fontSize: 13,
    backgroundColor: state.isSelected
      ? "#111"
      : state.isFocused
        ? "#f5f5f5"
        : "#fff",
    color: state.isSelected ? "#fff" : "#111",
  }),
};

export default function SaleDetailsSection({
  saleType,
  transportType,
  serviceType,
  deliveryFee,
  onSaleTypeChange,
  onTransportTypeChange,
  onServiceTypeChange,
  onDeliveryFeeChange,
}) {
  return (
    <div className="pos-sale-details-section">
      <h4 className="pos-section-label">Detalhes da venda</h4>

      <div className="pos-sale-details-field">
        <label className="pos-modal-label">Tipo de venda *</label>
        <Select
          value={SALE_TYPES.find((t) => t.value === saleType) || null}
          onChange={(opt) => onSaleTypeChange(opt.value)}
          options={SALE_TYPES}
          styles={selectStyles}
        />
      </div>

      <div className="pos-sale-details-field">
        <label className="pos-modal-label">Tipo de transporte</label>
        <Select
          value={TRANSPORT_TYPES.find((t) => t.value === transportType) || null}
          onChange={(opt) => onTransportTypeChange(opt.value)}
          options={TRANSPORT_TYPES}
          styles={selectStyles}
        />
      </div>

      <div className="pos-sale-details-field">
        <label className="pos-modal-label">Tipo de serviço</label>
        <Select
          value={SERVICE_TYPES.find((t) => t.value === serviceType) || null}
          onChange={(opt) => onServiceTypeChange(opt)}
          options={SERVICE_TYPES}
          styles={selectStyles}
        />
      </div>

      <div className="pos-sale-details-field">
        <label className="pos-modal-label">Valor do frete</label>
        <NumberFormat
          decimalSeparator=","
          prefix="R$"
          thousandSeparator="."
          inputType="number"
          decimalScale={2}
          fixedDecimalScale
          className="pos-modal-input"
          placeholder="Valor do Frete"
          value={deliveryFee}
          onValueChange={(e) => onDeliveryFeeChange(e.floatValue || 0)}
        />
      </div>
    </div>
  );
}
